export const PERSONA_VERIFICATION_STATUS = {
    IDLE: "idle",
    IN_PROGRESS: "inProgress",
} as const;

export type PersonaVerificationStatus =
    typeof PERSONA_VERIFICATION_STATUS[keyof typeof PERSONA_VERIFICATION_STATUS];

/** Inquiry statuses Persona reports through the `onComplete` callback. */
export const PERSONA_INQUIRY_STATUS = {
    COMPLETED: "completed",
    APPROVED: "approved",
    NEEDS_REVIEW: "needs_review",
    PENDING: "pending",
    FAILED: "failed",
    DECLINED: "declined",
    EXPIRED: "expired",
} as const;

/** Only these terminal statuses must suppress the confirmation redirect. */
const UNSUCCESSFUL_INQUIRY_STATUSES: readonly string[] = [
    PERSONA_INQUIRY_STATUS.FAILED,
    PERSONA_INQUIRY_STATUS.DECLINED,
    PERSONA_INQUIRY_STATUS.EXPIRED,
];

export const isUnsuccessfulInquiryStatus = (status?: string): boolean =>
    Boolean(
        status && UNSUCCESSFUL_INQUIRY_STATUSES.includes(status.toLowerCase())
    );
